import api from "services/api";
import { getSecureLocalItem } from "utils/secureSessionStorage";

const getAuthConfig = async () => {
  const token = getSecureLocalItem("token");
  return {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };
};

// Get roles
export const getRoles = async () => {
  return api.get("/v1/api/get-role-list");
};

// create role
export const createRole = async (roleData) => {
  return api.post("/v1/api/create-role", roleData);
};
